import { IStrangerUserPreview } from './../models/user/IStrangerUser/IStrangerUserPreview';
import { BerndMapper } from './../temp/BerndMapper';
import { NearbyAction, NearbyActions } from '../actions/NearbyActionCreator';
import { IPaginatedCollection, emptyPaginatedCollection } from '../models/collections/IPaginatedCollection';

export interface INearbyState {
    users: IPaginatedCollection<IStrangerUserPreview>;
    searchedUsers: IPaginatedCollection<IStrangerUserPreview>;
}

const NearbyDefault: INearbyState = {
    users: emptyPaginatedCollection<IStrangerUserPreview>(),
    searchedUsers: emptyPaginatedCollection<IStrangerUserPreview>(),
};

export function NearbyReducer(state: INearbyState = NearbyDefault, action: NearbyAction): INearbyState {
    switch (action.type) {
        case NearbyActions.FETCH_USERS_RESPONSE: {
            const { result, params } = action.payload;

            const collection = BerndMapper.mapToPaginatedCollection(params.isNext ? [...state.users._embedded.items, ...result] : result);

            return {
                ...state,
                users: collection,
            };
        }

        case NearbyActions.LIKE_STRANGER_USER: {
            const { userId } = action.payload;
            return {
                ...state,
                users: {
                    ...state.users,
                    _embedded: {
                        ...state.users._embedded,
                        items: state.users._embedded.items.map<IStrangerUserPreview>((x) => (x.Profilid === userId ? { ...x, IsLiked: true } : x)),
                    },
                },
            };
        }
        case NearbyActions.SEARCH_USERS_RESPONSE: {
            const { params, result } = action.payload;
            const resultPayload: any = result;
            const items = Array.isArray(resultPayload)
                ? resultPayload
                : Array.isArray(resultPayload?.data)
                ? resultPayload.data
                : Array.isArray(resultPayload?._embedded?.items)
                ? resultPayload._embedded.items
                : [];

            const collection = BerndMapper.mapToPaginatedCollection<IStrangerUserPreview>(items);
            const mergedItems = params?.isNext
                ? [...state.searchedUsers._embedded.items, ...collection._embedded.items]
                : collection._embedded.items;

            return {
                ...state,
                searchedUsers: {
                    ...collection,
                    _embedded: { items: mergedItems },
                },
            };
        }
        default:
            return state;
    }
}

export default NearbyReducer;
